import Utils from '@otrocheyon/js/services/utils';

export default class Instagram {

    constructor()
    {
        Instagram.ajax_instagram();
    }

    static ajax_instagram()
    {
        let $wrapper = $('[data-id="wpiris-instagram-wall"]');

        if ($wrapper.length > 0) {
            self = this;
            $.ajax({
                url: Theme.ajax_url,
                data: {
                    'action': 'social_wall',
                },
                type: 'POST',
                success: function (socialData) {
                    $wrapper.append(socialData);
                    Utils.lazy();
                }
            });
        }
    }
}
